import {
  TableCell,
  TableHead as TableHeadMUI,
  TableRow,
  TableSortLabel,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  handleSortChange: (sortName: string) => () => void
  activeSort: string
  sortDirection: 'desc' | 'asc'
}

export const TableHead = ({ handleSortChange, activeSort, sortDirection }: IProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))
  return (
    <TableHeadMUI>
      <TableRow>
        <TableCell align="center" />
        <TableCell padding="none">
          <TableSortLabel
            onClick={handleSortChange('name')}
            active={activeSort === 'name'}
            direction={sortDirection}
          >
            <HelperWrapper t="consumer-challenges-name-column" />
          </TableSortLabel>
        </TableCell>

        <TableCell align="center" padding="none">
          <HelperWrapper t="consumer-challenges-your-points-column" />
        </TableCell>

        <TableCell align="center" padding="none">
          <TableSortLabel
            onClick={handleSortChange('paid')}
            active={activeSort === 'paid'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="consumer-challenges-status-column" />
          </TableSortLabel>
        </TableCell>

        {!isMobile && (
          <TableCell align="center" padding="none">
            <TableSortLabel
              onClick={handleSortChange('start_date')}
              active={activeSort === 'start_date'}
              direction={sortDirection}
              sx={{
                marginLeft: '20px',
              }}
            >
              <HelperWrapper t="consumer-challenges-start-date-label" />
            </TableSortLabel>
          </TableCell>
        )}
        {!isMobile && (
          <TableCell align="center" padding="none">
            <TableSortLabel
              onClick={handleSortChange('end_date')}
              active={activeSort === 'end_date'}
              direction={sortDirection}
              sx={{
                marginLeft: '20px',
              }}
            >
              <HelperWrapper t="consumer-challenges-end-date-label" />
            </TableSortLabel>
          </TableCell>
        )}
      </TableRow>
    </TableHeadMUI>
  )
}
